import React from 'react';

const TypingAnimation = () => {
    return (
        <div className="flex items-center space-x-1 mt-3 mb-2">
            <div className="w-2 h-2 bg-gray-600 rounded-full animate-bounce delay-100"></div>
            <div className="w-2 h-2 bg-gray-600 rounded-full animate-bounce delay-200"></div>
            <div className="w-2 h-2 bg-gray-600 rounded-full animate-bounce delay-300"></div>
        </div>
    );
};

export default TypingAnimation;